import React from 'react';

import styles from './styles.module.css';

export const Divider = () => {
  return <div className={styles.divider}></div>;
};
